import axios from "axios";
import { Component } from "react";
import GeneralBloc from "../bloc/general_bloc";
import BaseWebService from "./base_web_service";
import EncrytionDecrytionService from "./encrytion_decrytion_service";

export default class CertificateCollectionStatusWebServices extends Component {
  //   static async getSubmittedDocuments(docClass, recMap) {
  //     let headers = await BaseWebService.headers(docClass);
  //     let resp = await axios.get(
  //       GeneralBloc.encodeAndDecodeURL(
  //         BaseWebService.baseUrl() + `/submittedDocs/${docClass}/${recMap}`
  //       ),
  //       { headers: headers }
  //     );
  //     let response = BaseWebService.baseResponseFromWeb(resp.data);
  //     return response;
  //   }

  static async getCertificateCollection(
    token,
    entity,
    page,
    fromDate,
    toDate,
    regions,
    searchBy,
    keyword,
    branches,
    agents,
    dateFilter
  ) {
    let payload={
      id: "df-cert-collection-status-list",
      pageNumber: page,
      criParams: {
        "proposal-dt-range": dateFilter,
        dtFrom: fromDate,
        dtTo: toDate,
        "proposal-attr-search": searchBy,
        searchBy: keyword,
        //   regions: regions,
        regions: regions,
        branches: branches,
        agents: agents,
      },
      sortBys: [
        {
          fieldName: "pPartName",
          asc: true,
        },
      ],
    }

    if(dateFilter!="range"){
      delete payload.criParams.dtFrom;
      delete payload.criParams.dtTo;      
    }
    let header=await BaseWebService.standardHeaders();
    let resp = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/v1/list`,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);    
    if (response.success) {
      let plainJsonStr =await EncrytionDecrytionService.decrypt(response.data);      
      response.data = JSON.parse(plainJsonStr); 
    }
     return response;
  }

  static async getCertificateCollectionDetail(token, entity, recMap) {
    let header=await BaseWebService.standardHeaders();
    let resp = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/v1/certCollectionStatusDetails/${recMap}`,
      {
        headers: header
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);    
    if (response.success) {
      let plainJsonStr =await EncrytionDecrytionService.decrypt(response.data);      
      response.data = JSON.parse(plainJsonStr); 
    }
     return response;
  }
}
